module.exports = __webpack_public_path__ + "img/banner2.796a8243.png";